import React from "react";
import { Route, Routes } from "react-router-dom";
import SingleAuditView from "./SingleAuditView";
import AuditsOverviewTable from "./AuditsOverviewTable";

function AuditView() {
  return (
    <div>
      <Routes>
        <Route index element={<AuditsOverviewTable />} />
        <Route path="/:year" element={<SingleAuditView />} />
      </Routes>
    </div>
  );
}

export default AuditView;
